import React from "react";
import {TextReaderProps} from "./types";
import SunEditor from "suneditor-react";
import "./style.less"

const TextReader: React.FC<TextReaderProps> = (props) => {
  const {value} = props
  return <div className="textReader_wrapper">
    <SunEditor setContents={value} setOptions={{
      buttonList: [],
      resizingBar: false,
      height: "auto",    // Автоматична висота
      minHeight: "100",    // Мінімальна висота
      maxHeight: "none",
    }} disable/>
  </div>
}

export default TextReader